<template>
  <div>
    <p
      class="font-semibold text-muted"
      @click="showModal"
      style="cursor: pointer"
    >
      رمز عبورتون رو فراموش کردید ؟
    </p>
    <a-modal v-model="visible" title="فراموشی رمزعبور">
      <template slot="footer">
        <a-button type="danger" key="back" @click="handleCancel">
          بستن
        </a-button>
        <a-button @click="handleOk"> ارسال </a-button>
      </template>
      <a-form id="forgetPass" class="login-form" :hideRequiredMark="true">
        <a-form-item class="mb-10" :colon="false">
          <a-input
            name="phone"
            v-model="phone"
            v-decorator="[
              'phone',
              {
                rules: [
                  {
                    required: true,
                    message: 'لطفا شماره همراه خود را وارد کنید',
                  },
                ],
              },
            ]"
            placeholder="0912*******"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      phone:"",
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    async handleOk() {
     let _this = this;
     await axios
        .post("/forget-password", {
            phone:this.phone
        })
        .then(function (response) {
          _this.$toast.success(response.data.message);
          _this.visible = false;

        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
    handleCancel() {
      this.visible = false;
    }
    }

};
</script>
